module.exports = __webpack_public_path__ + "static/media/empty-paint.5a070b1a.svg";